"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
exports.default = {
    "THEME": "Flow",
    "TRADEMARK": `© ${moment().format("YYYY")} Flow is a registered trademark of Liverpool Victoria General Insurance Group. Registered address: 57 Ladymead, Guildford, Surrey, GU1 1DB.`,
    "WHATEVER_YOU_DECIDE": "Whatever you decide, we’ll go with the Flow.",
    "COMPLAINT_EMAIL": "customerrelations_flow@lv.co.uk",
    "HELP_EMAIL": "flowinsurance@lv.co.uk",
    "UNDERWRITER": "Comprehensive cover, underwritten by LV=",
    "FAQ_CAR_URL": "FAQ CAR URL",
    "FAQ_HOME_URL": "FAQ HOME URL",
    "CONTACT_US_URL": "CONTACT US URL",
    "PRIVACY_NOTICE_URL": "PRIVACY NOTICE URL",
    "LEGAL_NOTICE_URL": "LEGAL NOTICE URL",
    "COOKIE_POLICY_URL": "COOKIE POLICY URL",
    "PRODUCT": "PRODUCT",
    "TIER_1": "TIER 1",
    "TIER_2": "TIER 2",
    "TIER_3": "TIER 3",
    "PRODUCT_TIER_1": "PRODUCT TIER 1",
    "PRODUCT_TIER_2": "PRODUCT TIER 2",
    "PRODUCT_TIER_3": "PRODUCT TIER 3",
    "CREDIT_WORDING": "Credit supplied by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_DISPLAY": "MOTOR CLAIMS WINDSCREEN PHONE_DISPLAY",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_TEL": "MOTOR CLAIMS WINDSCREEN_PHONE TEL",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_DISPLAY": "MOTOR CLAIMS WINDSCREEN PHONE ABROAD DISPLAY",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_TEL": "MOTOR CLAIMS WINDSCREEN PHONE ABROAD TEL",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_DISPLAY": "MOTOR CLAIMS BREAKDOWN PHONE_DISPLAY",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_TEL": "MOTOR CLAIMS BREAKDOWN PHONE TEL",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_DISPLAY": "MOTOR CLAIMS BREAKDOWN PHONE ABROAD DISPLAY",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_TEL": "MOTOR CLAIMS BREAKDOWN PHONE ABROAD TEL",
    "BRAND_URL": "#",
    "LET_US_KNOW_URL": "LET US KNOW URL",
    "HOW_TO_VIDEOS": undefined,
    "DOCUMENTS_TITLE": "Documents"
};
//# sourceMappingURL=resource.js.map